import { jsonMember, jsonObject } from 'typedjson';
import { ShippingMethodCode } from '../../../shared/enums/shipping-method-code';

@jsonObject
export class PublicShippingMethodCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: string;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly category!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(String)
  public readonly code!: ShippingMethodCode;
}
